module.exports = __webpack_public_path__ + "img/Polygon 9.f32a73f0.svg";